module.exports = __webpack_public_path__ + "img/demo3.501cd522.jpg";